/**
 * Вложенный диалог защиты несохранённых изменений: закрытие, Esc, клик по
 * подложке и навигация ‹ › при правках спрашивают, а не теряют их молча.
 * Разметка по эталону DesignCardModal.tsx:1700–1752.
 */

import React from 'react'
import { Button, Modal } from '../../../components/ui'

interface UnsavedChangesDialogProps {
  isOpen: boolean
  saving: boolean
  /** Подписи изменённых полей и характеристик. */
  dirtyLabels: string[]
  onCancel: () => void
  onDiscard: () => void
  onSaveAndContinue: () => void
}

export const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({
  isOpen,
  saving,
  dirtyLabels,
  onCancel,
  onDiscard,
  onSaveAndContinue,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onCancel}
    title="Несохранённые изменения"
    size="md"
    layer="nested"
    footer={
      <>
        <Button variant="secondary" onClick={onCancel}>Отмена</Button>
        <Button
          variant="ghost"
          className="text-red-600 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-950/50"
          onClick={onDiscard}
        >
          Не сохранять
        </Button>
        <Button loading={saving} onClick={onSaveAndContinue}>Сохранить и продолжить</Button>
      </>
    }
  >
    <div className="space-y-3">
      <p>Сохранить изменения перед продолжением?</p>
      <div className="rounded-md bg-amber-50 px-3 py-2.5 dark:bg-amber-950/30">
        <div className="text-xs font-medium text-amber-800 dark:text-amber-300">
          {dirtyLabels.length === 1 ? 'Изменено поле' : `Изменено полей: ${dirtyLabels.length}`}
        </div>
        <ul className="mt-1.5 list-inside list-disc text-xs text-amber-700 dark:text-amber-400">
          {dirtyLabels.map((label) => (
            <li key={label}>{label}</li>
          ))}
        </ul>
      </div>
    </div>
  </Modal>
)

export default UnsavedChangesDialog
